import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Request from "./Request";
import ajax from "../senders/ajax";

var _defaultSender = ajax();

function makeRunner(stack) {
  return stack.reduceRight(function (next, fn) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", fn.apply(this, [next.bind(this)]));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  });
}

export function setDefaultSender(sender) {
  _defaultSender = sender;
}
/**
 * 创建一个Coa请求执行器
 * @param  {Array} fns 中间件
 */

export function createCoa() {
  var fns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sender = arguments.length > 1 ? arguments[1] : undefined;

  if (!Array.isArray(fns)) {
    console.error('创建coa的fns参数不是数组类型', _typeof(fns), fns);
  } // mock中间件在生产环境下返回undefined而不是一个函数，需要特别过滤一下


  fns = fns.filter(function (fn) {
    return fn;
  });

  var _iterator = _createForOfIteratorHelper(fns),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fn = _step.value;

      if (typeof fn !== 'function') {
        console.error('创建coa的fns参数中包含非函数类型的中间件', _typeof(fn), fn);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var stack = [].concat(_toConsumableArray(fns), [sender || _defaultSender || ajax()]);
  var runner = makeRunner(stack);

  var coa = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, data, options) {
      var context;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              context = {
                request: new Request(url, data, options),
                response: null,
                error: undefined
              };
              _context2.next = 3;
              return runner.apply(context);

            case 3:
              if (!context.error) {
                _context2.next = 7;
                break;
              }

              throw context.error;

            case 7:
              return _context2.abrupt("return", context.response);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function coa(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  coa.run = coa;
  return coa;
}